import { render, staticRenderFns } from "./WatchingFilm.vue?vue&type=template&id=019a5d5e&scoped=true&"
import script from "./watchingFilm?vue&type=script&lang=js&"
export * from "./watchingFilm?vue&type=script&lang=js&"
import style0 from "./watchingFilm.scss?vue&type=style&index=0&id=019a5d5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a5d5e",
  null
  
)

export default component.exports